/**
 * Admin Stone Entrega: consulta e cancelamento de deliveries pelo time de suporte.
 *
 * Fluxo: DeliveryTable (filtros + Enter) -> useDeliverySearch -> slice (features/adminStoneEntrega)
 *        -> back /ferramentas/admin-stone-entrega/consulta -> DeliveryTable (lista)
 *        -> clique na linha -> DeliveryDrawer (etapas, fotos e cancelamento).
 */
import React, { useState } from "react";
import { Card, NotificationProvider } from "@stonelog/stonelog-design-system";
import { useRoles } from "@hooks/useRoles";
import { ROLE_LIGA } from "@utils/common";
import appConfig from "../../../consumingApi/services/appConfig";
import { PageLayout } from "../../../Layout/PageLayout";
import NotificationLayer from "@components/NotificationLayer";
import PageHeader from "@components/PageHeader";
import Breadcrumbs from "../../../components/Breadcumbs";
import DeliveryDrawer from "./components/DeliveryDrawer";
import DeliveryTable from "./components/DeliveryTable";
import { useDeliverySearch } from "./useDeliverySearch";

import * as S from "./styles";

function AdminStoneEntregaContent() {
  const search = useDeliverySearch();

  const [open, setOpen] = useState(false);
  const [selectedDeliveryId, setSelectedDeliveryId] = useState(null);

  // O drawer lê a delivery da lista (não de uma cópia), então um refresh após o
  // cancelamento atualiza a linha e o drawer juntos.
  const selectedDelivery = search.deliveries.find((d) => d.id === selectedDeliveryId);

  const handleSelect = (deliveryId) => {
    setSelectedDeliveryId(deliveryId);
    setOpen(true);
  };

  return (
    <PageLayout>
      <S.PageContainer>
        <Breadcrumbs />
        <PageHeader title="Admin Stone Entrega" />

        <DeliveryDrawer
          open={open}
          onClose={() => setOpen(false)}
          delivery={selectedDelivery}
        />

        <Card.Root>
          <Card.Body className="ginga-lib-card-body">
            <Card.Header>
              <Card.HeaderText
                title="Deliveries Stone Entrega"
                subtitle="Busque uma delivery e clique nela para acompanhar as etapas ou cancelá-la."
              />
            </Card.Header>
            <DeliveryTable search={search} onSelect={handleSelect} />
          </Card.Body>
        </Card.Root>
      </S.PageContainer>
    </PageLayout>
  );
}

// Tela exclusiva do perfil Liga (o back também recusa com 403 quem não tem a role)
function AccessDenied() {
  return (
    <PageLayout>
      <S.PageContainer>
        <Breadcrumbs />
        <PageHeader title="Admin Stone Entrega" />
        <Card.Root>
          <Card.Body className="ginga-lib-card-body">
            <Card.Header>
              <Card.HeaderText
                title="Acesso restrito"
                subtitle="Esta tela é exclusiva do perfil Liga."
              />
            </Card.Header>
          </Card.Body>
        </Card.Root>
      </S.PageContainer>
    </PageLayout>
  );
}

// O provider fica aqui porque os toasts (useNotify) são disparados de dentro da tela
export default function AdminStoneEntrega() {
  const roles = useRoles();
  if (appConfig.requirePerfilLiga && !roles.includes(ROLE_LIGA)) return <AccessDenied />;

  return (
    <NotificationProvider>
      <NotificationLayer />
      <AdminStoneEntregaContent />
    </NotificationProvider>
  );
}
